import { defineRule } from 'vee-validate'
import { i18n } from '@/i18n.js'

defineRule('required_without_all_set_or_true', (value, others) => {
  if (value) {
    return true
  }
  for (const other of others) {
    if (!['false', null, undefined, false].includes(other)) return true
  }
  return i18n.global.t('form.fieldIsRequired')
})
